/**
 * Minimal SVG pie chart — no dependencies.
 * Mirrors the original Ratchet Knowledge Base visualization.
 *
 * data: { "scheduled_job": 12.5, "duplicate_charge": 60.0, ... } (percentages)
 */
const COLORS = [
  "#0066FF", "#10B981", "#F59E0B", "#EF4444", "#A78BFA",
  "#06B6D4", "#EC4899", "#84CC16", "#F97316", "#8B5CF6",
];

export function PieChart({ data, size = 160, showLegend = true }) {
  const entries = Object.entries(data || {}).filter(([, v]) => v > 0);
  if (entries.length === 0) {
    return <div className="text-xs text-white/40 font-mono">no data</div>;
  }
  const total = entries.reduce((s, [, v]) => s + Number(v), 0) || 1;
  const cx = size / 2, cy = size / 2, r = size / 2 - 4;
  let acc = 0;
  const slices = entries.map(([label, value], i) => {
    const frac = Number(value) / total;
    const startAngle = acc * 2 * Math.PI - Math.PI / 2;
    acc += frac;
    const endAngle = acc * 2 * Math.PI - Math.PI / 2;
    const x1 = cx + r * Math.cos(startAngle);
    const y1 = cy + r * Math.sin(startAngle);
    const x2 = cx + r * Math.cos(endAngle);
    const y2 = cy + r * Math.sin(endAngle);
    const largeArc = frac > 0.5 ? 1 : 0;
    const d = entries.length === 1
      ? `M ${cx - r} ${cy} A ${r} ${r} 0 1 1 ${cx + r} ${cy} A ${r} ${r} 0 1 1 ${cx - r} ${cy} Z`
      : `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;
    return { label, value, d, color: COLORS[i % COLORS.length] };
  });
  return (
    <div className="flex items-center gap-4">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {slices.map((s) => (<path key={s.label} d={s.d} fill={s.color} stroke="#0A0A0A" strokeWidth="1.5" />))}
      </svg>
      {showLegend && (
        <div className="space-y-1 text-xs flex-1">
          {slices.map((s) => (
            <div key={s.label} className="flex items-center justify-between gap-3 font-mono text-[11px]">
              <div className="flex items-center gap-2 min-w-0">
                <span className="w-2.5 h-2.5 shrink-0" style={{ background: s.color }} />
                <span className="truncate text-white/70">{s.label}</span>
              </div>
              <span className="text-white/50 shrink-0">{Number(s.value).toFixed(1)}%</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
